import React from 'react';

import CancelledIcon from '../../../../icons/order-status/001-cancelled.svg';
import CompletedIcon from '../../../../icons/order-status/002-completed.svg';
import CreatedIcon from '../../../../icons/order-status/003-created.svg';
import DelayedIcon from '../../../../icons/order-status/004-delayed.svg';
import PreparedIcon from '../../../../icons/order-status/005-prepared.svg';
import PayedIcon from '../../../../icons/order-status/006-payed.svg';
import ShippedIcon from '../../../../icons/order-status/007-shipped.svg';
import ProducedIcon from '../../../../icons/order-status/008-produced.svg';
import ReturnRequestedIcon from '../../../../icons/order-status/009-return-requested.svg';
import ReturnShippedIcon from '../../../../icons/order-status/010-return-shipped.svg';
import ReturnedIcon from '../../../../icons/order-status/011-returned.svg';
import RefundedIcon from '../../../../icons/order-status/012-refunded.svg';

const statusIcons = {
  cancelled: CancelledIcon,
  completed: CompletedIcon,
  created: CreatedIcon,
  delayed: DelayedIcon,
  prepared: PreparedIcon,
  payed: PayedIcon,
  shipped: ShippedIcon,
  produced: ProducedIcon,
  'return-requested': ReturnRequestedIcon,
  'return-shipped': ReturnShippedIcon,
  returned: ReturnedIcon,
  refunded: RefundedIcon,
};

const OrderStatusIcon = ({ name, fill = 'white', size = 48 }) => {
  const Icon = statusIcons[name];
  return Icon ? <Icon width={size} height={size} style={ { fill } } /> : null;
};

export const getOrderStatusIconsList = () => Object.keys(statusIcons);

export default OrderStatusIcon;